import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThumbnailList } from '../ThumbnailList';
import { utils } from '@ohif/core';
import { useThumbnailLocationListener } from '@state';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';
const { formatDate } = utils;

const StudyItem = ({
  servicesManager,
  date,
  description,
  numInstances,
  patientName,
  patientBirthday,
  patientSex,
  accessionNumber,
  isExpanded,
  displaySets,
  modalities,
  isActive,
  onClick,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  activeDisplaySetInstanceUIDs,
  viewPreset = 'thumbnails',
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
}: withAppTypes) => {
  const thumbnailLocation = useThumbnailLocationListener();
  return (
    <Accordion
      type="single"
      collapsible
      onClick={onClick}
      onKeyDown={() => { }}
      role="button"
      tabIndex={0}
      defaultValue={isActive ? 'study-item' : undefined}
    >
      <AccordionItem value="study-item" className={thumbnailLocation == 'top' ? 'flex' : ''}>
          <AccordionTrigger
            className={classnames('group w-full rounded bg-[#383842] hover:bg-[#383842]')}
          >
            <div className="flex h-[40px] w-full flex-row overflow-hidden">
              <div className="flex w-full flex-row items-center justify-between">
                <div className="flex min-w-0 flex-col items-start text-[11px]">
                  <Tooltip>
                    <TooltipContent>
                      {`${accessionNumber} ${formatDate(date, 'YYYY-MM-DD')}`}
                    </TooltipContent>
                    <TooltipTrigger className="w-full">
                      <div className="h-[13px] w-full max-w-[160px] overflow-hidden truncate whitespace-nowrap text-left text-white">
                        {`${accessionNumber} ${formatDate(date, 'YYYY-MM-DD')}`}
                      </div>
                    </TooltipTrigger>
                  </Tooltip>
                  <Tooltip>
                    <TooltipContent>
                      {`${patientName} ${patientBirthday} ${patientSex}`}
                    </TooltipContent>
                    <TooltipTrigger className="w-full">
                      <div className="h-[13px] w-full max-w-[160px] overflow-hidden truncate whitespace-nowrap text-left text-white">
                        {`${patientName} ${patientBirthday} ${patientSex}`}
                      </div>
                    </TooltipTrigger>
                  </Tooltip>
                  <Tooltip>
                    {description ? <TooltipContent>{description}</TooltipContent> : null}
                    <TooltipTrigger className="w-full">
                      <div className="h-[13px] w-full overflow-hidden truncate whitespace-nowrap text-left text-white">
                        {description || ''}
                      </div>
                    </TooltipTrigger>
                  </Tooltip>
                </div>
                <div className="flex flex-col items-end pl-[10px] text-[12px] text-[#e51c47]">
                  <div className="max-w-[150px] overflow-hidden text-ellipsis">{modalities}</div>
                  <div>{numInstances}</div>
                </div>
                {StudyMenuItems && (
                  <div className="ml-2 flex items-center">
                    <StudyMenuItems StudyInstanceUID={StudyInstanceUID} />
                  </div>
                )}
              </div>
            </div>
          </AccordionTrigger>
        <AccordionContent
          onClick={event => {
            event.stopPropagation();
          }}
        >
          {isExpanded && displaySets && (
            <ThumbnailList
              servicesManager={servicesManager}
              thumbnails={displaySets}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              onThumbnailClick={onClickThumbnail}
              onThumbnailDoubleClick={onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              viewPreset={viewPreset}
              ThumbnailMenuItems={ThumbnailMenuItems}
              patientName={patientName}
              patientBirthday={patientBirthday}
              patientSex={patientSex}
              accessionNumber={accessionNumber}
              description={description}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.any,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  patientName: PropTypes.string.isRequired,
  patientBirthday: PropTypes.string,
  patientSex: PropTypes.string,
  accessionNumber: PropTypes.string,
  trackedSeries: PropTypes.number,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  displaySets: PropTypes.array,
  activeDisplaySetInstanceUIDs: PropTypes.array,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  viewPreset: PropTypes.string,
  StudyMenuItems: PropTypes.func,
  StudyInstanceUID: PropTypes.string,
};

export { StudyItem };
